
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/monet",
      function () {
        return require("private-next-pages/locale/monet.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/monet"])
      });
    }
  